import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Redirect} from 'react-router-dom'
import {withBoundary} from 'Components/ErrorBoundary'
import DocumentTitle from 'react-document-title'
import {Elements} from 'react-stripe-elements'
import StripeComponent from './StripeComponent'

import style from './style.sass'

@withBoundary
@inject('store') @observer
class Checkout extends Component {
  render() {
    const {user} = this.props.store
    const {cards, plans} = this.props.store.subscription
    const {planSettings, selectedPlan} = user
    const {is_staff} = user.data
    const trial_till = user.data.account ? user.data.account.trial_till : null
    const is_subscribed = user.data.account ? user.data.account.is_subscribed : false
    const trialEnd = new Date(trial_till)
    let trial = false
    if (trial_till) {
      trial = trialEnd > new Date()
    }
    if (is_subscribed && !is_staff && cards.loaded && cards.data.length > 0) {
      return <Redirect push to='/'/>
    }
    const trialEndFormatted = trialEnd.toLocaleString('en-US', {month: 'short', day: 'numeric', year: 'numeric'})
    const selectedPlanObj = plans.data.filter(plan => plan.id === selectedPlan)
    const planName = selectedPlanObj[0] ? selectedPlanObj[0].name : planSettings[0].name
    return(
      <Elements>
        <div className='card' styleName='container'>
          <DocumentTitle title='Checkout'/>
          {trial &&
            <div>
              <p key='message' styleName='trial-message'>Don&apos;t worry, Your card won&apos;t be charged until the end of your trial on {trialEndFormatted}</p>
              <hr key='separator'/>
            </div>
          }
          {planSettings[0].price &&
            <div styleName='plan'>
              <div styleName='card'>
                <h5>Selected Plan</h5>
                <h3 styleName='name'>{planName}</h3>
              </div>
              <p>{selectedPlanObj[0] ? selectedPlanObj[0].price : planSettings[0].price}</p>
            </div>
          }
          <StripeComponent/>
        </div>
      </Elements>
    )
  }
}

export default Checkout
